import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/vhosts/dailyneedsproducts.com/httpdocs/src/app/vendor/[slug]/VendorClient.tsx");
